<template>
    <div class="display-leito opaco ocupado bordavermelha" id="leito-transferencia" @click="etapaAnterior()">
        <div class="cod_enf_leito mt-1" >
            <span class="cod_enfermaria">{{leitoTransferencia.leitoCodigoEnfermaria}}</span>
            <span class="cod_leito">{{leitoTransferencia.leitoCodigo}}</span>
        </div>
        <div class="linha_divisoria"></div>
        <figure class="icone_leito">
            <img src="/publico/img/icone_leito.svg" alt="">
        </figure>
 
        <!-- <div class="longa-icone" v-if="dados.leitoStatus == 1 && dados.LongaPermanencia == '1'">L</div> -->

        <div id="tooltip-container-transferencia" style="display: none;">
            <strong>{{leitoTransferencia.pacienteNome}}</strong>
            <p class="my-0">
                <strong>Sexo: </strong>{{leitoTransferencia.leitoSexo}}
                <strong> Idade:</strong> {{leitoTransferencia.pacienteIdade}}
                <strong> Nasc:</strong> {{leitoTransferencia.pacienteDataNascimento}}
            </p>
            <p class="my-0"><strong>Dt. Admissão:</strong> {{leitoTransferencia.DataHoraInternacao}}</p>
            <p class="my-0"><strong>Dt. Admissão Leito:</strong> {{leitoTransferencia.dataHoraInternacaoLeito}}</p>
            <p class="my-0"><strong>Enfermaria:</strong> {{leitoTransferencia.leitoNomeEnfermaria}}</p>
            <p class="my-0"><strong>CNS:</strong> {{leitoTransferencia.pacienteCns}}</p>
            <p class="my-0"><strong>AIH:</strong> xxx</p>
        </div>
    </div>
</template>

<script>
import tippy from 'tippy.js'
import 'tippy.js/themes/light-border.css'
export default {
    mounted() {
        let conteudo = document.querySelector("#tooltip-container-transferencia").innerHTML
        tippy('#leito-transferencia',
                {
                    animation: 'shift-away',
                    theme: 'azulprefeitura',
                    arrow: true,
                    content: conteudo
                }
            );
    },
    computed: {
        leitoTransferencia () {
            return this.$store.getters['transferir/getLeitoTransferencia']
        }
    },
    watch: {
        leitoTransferencia (value) {
            let tooltip = document.querySelector('#leito-transferencia')

            setTimeout(() => {
                let conteudo = document.querySelector("#tooltip-container-transferencia").innerHTML
                tooltip._tippy.set({
                    content: conteudo,
                })
            }, 100)
        }
    },
    methods: {
        etapaAnterior () {
            this.$store.commit('leitos/setListagemFiltradaStatus', 7)
            this.$store.commit('transferir/setLeitoTransferencia', null)
        }
    }
}
</script>

<style>
    
.bordavermelha {
    border: 1px solid red;
}
 
</style>
